<!-- External Link Confirmation Modal -->
<div class="modal fade" id="externalLinkModal" tabindex="-1" aria-labelledby="externalLinkModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-dark text-white border-secondary">
            <div class="modal-header border-secondary">
                <h5 class="modal-title fw-bold" id="externalLinkModalLabel">External Link</h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                    aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="text-center mb-4">
                    <i class="bi bi-box-arrow-up-right text-danger" style="font-size: 3rem;"></i>
                </div>
                <p>You are about to be redirected to an external website.</p>
                <div class="p-3 bg-black bg-opacity-50 rounded border border-secondary mb-3">
                    <div class="small text-secondary text-uppercase fw-bold mb-1">Destination URL</div>
                    <div class="text-danger text-break">{{ externalUrl() }}</div>
                </div>
                <p class="small text-muted mb-0">Rival Forge does not control the content of external websites. Please
                    ensure you trust the destination before proceeding.</p>
            </div>
            <div class="modal-footer p-0 border-0 gap-0">
                <button type="button" class="btn btn-dark w-50 m-0 rounded-0 rounded-bottom-start fw-bold"
                    style="height: 4rem;" data-bs-dismiss="modal">Cancel</button>
                <button type="button"
                    class="btn btn-danger w-50 m-0 rounded-0 rounded-bottom-end d-flex align-items-center justify-content-center"
                    style="height: 4rem;" data-bs-dismiss="modal" (click)="confirm()" title="Proceed to External Link">
                    <span class="me-2 fw-bold">Proceed</span>
                    <svg class="arrow-icon text-white" style="width: 2rem; height: 2rem;" fill="none"
                        stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3">
                        </path>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</div>
